import { Pipe, PipeTransform } from '@angular/core';
import { taxFilingStatusDropdown } from '../consts';

@Pipe({
  name: 'taxFilingStatus',
  standalone: true,
})
export class TaxFilingStatusPipe implements PipeTransform {
  private readonly statusMap = new Map<number, string>(taxFilingStatusDropdown().map(({ id, description }) => [id, description]));

  transform(value: number | null | undefined): string {
    if (value == null) return '';
    return this.statusMap.get(value) ?? `--`;
  }
}
